"use strict";

import * as Constants from "./Constants.js";

const displayedProductsSortDefault = [Constants.ORGANIZATION_PRODUCT_SENTRI7, Constants.ORGANIZATION_PRODUCT_QUANTIFI, Constants.ORGANIZATION_PRODUCT_VERIFORM, Constants.ORGANIZATION_PRODUCT_POCADVISOR];

const displayedProductsSortByTeams = {
    "Infection Prevention": [Constants.ORGANIZATION_PRODUCT_SENTRI7, Constants.ORGANIZATION_PRODUCT_VERIFORM]
};

const OrganizationProductFilter = {
    getDisplayedProductsList:function(){
        var current = displayedProductsSortByTeams[TeamName];
        if (current == null) {
            return displayedProductsSortDefault;
        }
        return current;
    },

    filterProducts: function (products){
        const displayedList = this.getDisplayedProductsList();
        return products.filter(product => displayedList.some(p => p === product.ProductName));
    },

    filterProductsJS: function (products){
        const displayedList = this.getDisplayedProductsList();
        var result = products.filter(product => displayedList.some(p => p === product.productName));
        return result;
    }

};

export default OrganizationProductFilter;
